/* PDP gallery at every width: a snap carousel with a thumbnail strip beneath it,
   plus arrows for pointer users. Desktop used to stack every image two-up, which
   ran a 21-image product past 10,000px of page.

   The thumbs are built FROM the gallery's live children rather than from Liquid,
   because selecting a colour makes mt-core.js re-order those children (it hoists
   the chosen colour's photo into first place). A MutationObserver rebuilds the
   strip whenever that happens, so thumbs and slides can never drift apart. */
(function () {
  function init() {
    var gallery = document.querySelector('.cx-pdp__gallery');
    var strip = document.querySelector('[data-cx-thumbs]');
    if (!gallery || !strip || gallery.dataset.cxReady) return;
    gallery.dataset.cxReady = '1';
    var prev = document.querySelector('[data-cx-gprev]');
    var next = document.querySelector('[data-cx-gnext]');

    function slides() {
      return Array.prototype.slice.call(gallery.querySelectorAll('img'));
    }

    /* Horizontal offset of a slide inside the scroller. */
    function offsetWithin(img) {
      return gallery.scrollLeft
        + (img.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
    }

    function build() {
      strip.innerHTML = '';
      slides().forEach(function (img, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cx-thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'View image ' + (i + 1));
        var t = document.createElement('img');
        // reuse the already-decoded source; the browser serves it from cache
        t.src = img.currentSrc || img.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
        b.addEventListener('click', function () {
          // offsetLeft is relative to the offset parent, not the gallery, so measure
          // with rects. behavior:'smooth' is deliberately NOT used — Chromium cancels
          // a smooth scroll inside a `scroll-snap-type: mandatory` scroller and the
          // scroller stays at 0.
          gallery.scrollTo({ left: offsetWithin(img), behavior: 'auto' });
          markActive();
        });
        strip.appendChild(b);
      });
      var many = strip.children.length > 1;
      strip.hidden = !many;
      if (prev) prev.hidden = !many;
      if (next) next.hidden = !many;
    }

    function markActive() {
      var kids = slides();
      if (!kids.length) return;
      var mid = gallery.scrollLeft + gallery.clientWidth / 2;
      var idx = 0;
      kids.forEach(function (img, i) {
        if (offsetWithin(img) < mid) idx = i;
      });
      Array.prototype.forEach.call(strip.children, function (b, i) {
        b.classList.toggle('is-active', i === idx);
      });
    }

    /* step one slide; the scroller's own width is the slide width */
    function step(dir) {
      var kids = slides();
      if (!kids.length) return;
      var mid = gallery.scrollLeft + gallery.clientWidth / 2;
      var idx = 0;
      kids.forEach(function (img, i) { if (offsetWithin(img) < mid) idx = i; });
      var target = kids[Math.min(kids.length - 1, Math.max(0, idx + dir))];
      gallery.scrollTo({ left: offsetWithin(target), behavior: 'auto' });
      markActive();
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    build();

    var t = null;
    gallery.addEventListener('scroll', function () {
      if (t) cancelAnimationFrame(t);
      t = requestAnimationFrame(markActive);
    }, { passive: true });

    // swatch selection re-orders the gallery; keep the strip in step
    new MutationObserver(function () {
      build();
      gallery.scrollLeft = 0;
      markActive();
    }).observe(gallery, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
